import { Record, List, fromJS } from 'immutable';

const contentFileApi = {
  contentName: 'Default Menu Item Image',
  contentUrl: null,
  createBy: 0,
  createTime: null,
  description: 'Menu Item Image',
  dimensions: [
    {
      length: 0,
      units: 0,
      width: 0,
    },
  ],
  id: 0,
  sizes: [
    {
      size: 0,
      type: 0,
      units: 0,
    },
  ],
};

const defaultValues = {
  id: null,
  designSectionId: null,
  menuItemId: null,
  title: '',
  description: '',
  price: 0,
  userCategoryId: null,
  menuItemImageName: '',
  menuItemImageUrl: '',
  menuItemImageDesc: '',
  ordinal: 0,
  contentFileApi: fromJS(contentFileApi),
  menuItemOrdinal: 0,
  recipes: new List(),
  archived: false,
  createdBy: null,
  created: null,
  updatedBy: null,
  updated: null,
  loadToCanvas: false,
};

export default class DesignItem extends Record(defaultValues, DesignItem) {
  constructor(values) {
    super({
      ...values,
      contentFileApi: values && values.contentFileApi
                      ? fromJS(values.contentFileApi) : defaultValues.contentFileApi,
    });
  }

  static filterByDesignSectionId(designItems, id) {
    return designItems.filter((item) => {
      return item.get('designSectionId') === id;
    });
  }

  static deleteDesginItemByIndex(designItems, index) {
    return designItems.delete(index);
  }

  static insertDesignItemByIndex(designItems, index, designItem) {
    return designItems.insert(index, designItem);
  }

  static sortDesignItemsByOrdinal(designItems) {
    return designItems.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static updateDesignItemOrdinalsFromIndex(designItems) {
    return designItems.map((item, index) => {
      return item.set('ordinal', index);
    });
  }
}
export const DesignItems = (data) => {
  let designItems = new List();
  if (data) {
    data.forEach((value) => {
      designItems = designItems.push(new DesignItem(value));
    });
  }
  return designItems;
};
